// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>13</span>&nbsp;&nbsp;You have a mighty arm;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;strong is your hand and high is your right hand.<br> </p> </div></div>";
// Exports
module.exports = code;